import script from "./HomeWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeWarning.vue?vue&type=script&setup=true&lang=js"

import "./HomeWarning.vue?vue&type=style&index=0&id=221f23aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-221f23aa"]])

export default __exports__